import { render, staticRenderFns } from "./OwnerCreate.vue?vue&type=template&id=4e67afe8&scoped=true"
import script from "./OwnerCreate.vue?vue&type=script&lang=js"
export * from "./OwnerCreate.vue?vue&type=script&lang=js"
import style0 from "./OwnerCreate.vue?vue&type=style&index=0&id=4e67afe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67afe8",
  null
  
)

export default component.exports